import { getAuthenticatedRoutes, getUnauthenticatedRoutes } from '@/routes.tsx';
import * as Sentry from '@sentry/react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import useCustomers from '@/hooks/use-customers.ts';
import useAuth from '@/hooks/useAuth.ts';
import useConfig from '@/hooks/useConfig.ts';
import useTheme from '@/hooks/useTheme.ts';

import LoadingPage from '@/pages/LoadingPage.tsx';

import { useAuthStore } from '@/stores/authStore.ts';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

export const Router = () => {
    const { auth_user, isUserInGroup } = useAuth();
    const { selected_customer, selected_location } = useConfig();
    const isUserSet = useAuthStore((state) => state.is_user_set);
    useCustomers();
    useTheme();

    const getBrowserRouter = (): ReturnType<typeof sentryCreateBrowserRouter> | undefined => {
        if (auth_user && !selected_customer) return undefined;

        const browserRouter = sentryCreateBrowserRouter(
            auth_user ? getAuthenticatedRoutes(selected_customer, isUserInGroup) : getUnauthenticatedRoutes()
        );
        return browserRouter;
    };

    const router = getBrowserRouter();

    const isLegacyLocation = !!selected_location && 'config' in selected_location;

    if (
        !isUserSet ||
        (isUserSet && auth_user && (!selected_customer || !selected_location || isLegacyLocation)) ||
        !router
    ) {
        return <LoadingPage />;
    }

    return <RouterProvider router={router} />;
};
